import { gql } from '@apollo/client';

export const fetchInvoicesForTransactionAccount = gql`
  query fetchInvoicesForTransactionAccountInPPC(
    $id: ID!
    $searchOptions: ConnectionSearchOptions
    $filterOptions: InvoicesFilterOptions
  ) {
    transactionAccount(id: $id) {
      id
      invoices(searchOptions: $searchOptions, filterOptions: $filterOptions) {
        totalCount
        nodes {
          id
          invoiceNumber
          sourceSystem
          paymentMethod
          paymentMethodId
          creditCardMaskedNumber
          dueDate
          createdDate: createdTimestamp
          grandTotal: total
          paymentCurrency
          pricingCurrency
          transactionAccountId
          refunds {
            id
            type
            createdDate
            creditNoteNumber
            sourceSystem
            total
            currency
            status
            arn
          }
          status
          dunningStatus {
            errorCode
          }
          shipTo {
            id
            fullName
            address {
              address1
              address2
              city
              state
              country
              postalCode
            }
          }
          purchaseOrderNumber
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

export const FetchInvoicesForTransactionAccountWithContext = gql`
  query FetchInvoicesForTransactionAccountWithContext(
    $id: ID!
    $queryString: String
    $partnerSearchContext: PartnerSearchContext
    $pageParams: InvoicePageParams
    $isOrgSearchEnabled: Boolean
  ) {
    transactionAccount(id: $id) {
      id
      partnerInvoices(
        queryString: $queryString
        partnerSearchContext: $partnerSearchContext
        pageParams: $pageParams
        isOrgSearchEnabled: $isOrgSearchEnabled
      ) {
        totalCount
        nodes {
          id
          invoiceNumber
          sourceSystem
          paymentMethod
          paymentMethodId
          creditCardMaskedNumber
          dueDate
          createdDate: createdTimestamp
          grandTotal: total
          paymentCurrency
          pricingCurrency
          pdfLink
          transactionAccountId
          refunds {
            id
            type
            createdDate
            creditNoteNumber
            sourceSystem
            total
            currency
            status
            arn
          }
          status
          dunningStatus {
            errorCode
          }
          shipTo {
            id
            fullName
            address {
              address1
              address2
              city
              state
              country
              postalCode
            }
          }
          purchaseOrderNumber
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;
